import actionTypes from '../../action-types'

export default (id) => ({
  type: actionTypes.CUSTOMERS.FETCH,
  payload: {
    id,
  },
})
